<template>
    <v-sheet v-if="typeDialog === 'delete'" color="bgtopology" width="90%" class="defaultCard" style="margin: 0 auto !important;">
        <h1 class="my-5"> {{ t('title.delUser')}} </h1>
        <span class="bodyTEXT">
            {{ t('labels.bodyDialog.deleteUser') }} {{ nombre }}
        </span>
        <v-divider class="my-4"></v-divider>
        <v-row :justify="smAndDown ? 'center' : 'end'" class='ma-0 mt-6 mb-2'>
            <v-btn :class="smAndDown?'ma-2':'mx-2'" color="success" @click="deleteUser()" :block="xs">{{ t('buttons.yes') }}</v-btn>           
            <v-btn :class="smAndDown?'ma-2':'mx-2'" color="red" @click="emitDialogClose()" :block="xs">{{ t('buttons.not') }}</v-btn>
        </v-row>
    </v-sheet>

    <v-sheet v-else color="bgtopology" width="100%"  class="defaultCard">
        <v-row class="ma-0" justify="space-between" style="align-items: center !important;">
            <v-col class="pa-0" cols="10">
                <v-sheet color="transparent" v-if="typeDialog === 'add'">
                    <h4 v-if="xs"> {{ t('title.addUser')}} </h4>
                    <h2 v-else> {{ t('title.addUser')}}</h2>
                </v-sheet>
                <v-sheet color="transparent" v-if="typeDialog === 'edit'">
                    <h4 v-if="xs"> {{ t('title.edtUser')}} </h4>
                    <h2 v-else> {{ t('title.edtUser')}}</h2>
                </v-sheet>
            </v-col>
            <v-col class="pa-0" cols="1">
                <v-btn icon="mdi-close" variant="plain" @click="emitDialogClose()"></v-btn>
            </v-col>                    
        </v-row>
        <v-divider class="mt-4 mb-7"></v-divider>
        <v-form v-model="valid" >
            <v-row>

                 <!-- IP Field -->
                 <v-col cols="12" sm="4">
                    <v-text-field
                        v-model="nombre"
                        :label="t('labels.name') + ' *'"                        
                        variant="underlined"
                        density="compact"
                        :rules="fieldRules"
                    ></v-text-field>
                </v-col>

                <!-- Title Field -->
                <v-col cols="12" sm="4">
                    <v-select
                        v-model="asignado"
                        :items="itemList"
                        :label="t('labels.assigned') + ' *'"
                        variant="underlined"
                        density="compact"
                        :rules="fieldRules"
                    ></v-select>
                </v-col>

                <v-col cols="12" sm="4">
                    <v-select
                        v-model="turno"
                        :items="['diurno','nocturno']"
                        :label="t('labels.turn') + ' *'"
                        variant="underlined"
                        density="compact"
                        :rules="fieldRules"
                    ></v-select>
                </v-col>

            </v-row>
            

            <v-btn v-if="typeDialog === 'edit'" @click="editUser()" :disabled="(!valid && valid !== null && valid !== undefined) || (disableEDTbtn)" :class="smAndDown ? 'mt-3' : 'mt-10'" prepend-icon="mdi-pencil" color="success" block>
                {{ t('buttons.change' ) }}
            </v-btn>

            <v-btn v-if="typeDialog === 'add'" @click="addNewUser()" :disabled="(!valid && valid !== null && valid !== undefined) || disableAddbtn" class="mt-10" prepend-icon="mdi-check-circle" color="success" block>
                {{ t('buttons.add' ) }}
            </v-btn>

        </v-form>
    </v-sheet>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';

/********************************
 ************ STORE *************
 *******************************/
import { useStore } from 'vuex';
const store = useStore();

/********************************
 *********** VUETIFY ************
 *******************************/
import { useDisplay } from 'vuetify';
const {xs,smAndDown } = useDisplay();

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

/********************************
 ********** CONSTANTES **********
 *******************************/
import { LABELS } from '@/constants/labels';

/********************************
 ********** INTERFACES **********
 *******************************/
import { postAddUserData, postDeleteUserData, postEditUserData } from '@/services/RAOS/Admin';

const props = defineProps({
    itemObject  : { type: Object, required:true }
})
const emits = defineEmits( ['closeDialog'] );

const finalItem = computed(() => props.itemObject);

const id = ref(finalItem.value.id);
const nombre = ref(finalItem.value.nombre);
const asignado = ref(finalItem.value.asignado);
const turno = ref(finalItem.value.turno);
const typeDialog = ref(finalItem.value.typeDialog);


const itemList   = computed(()=>store.state.arrayListItems.map( (item:any) => item.ip));

const newAdd        = ref(false);

const disableEDTbtn = computed( ()=>
    (nombre.value === finalItem.value.nombre &&
    asignado.value === finalItem.value.asignado && turno.value === finalItem.value.turno)
)

const disableAddbtn = computed( ()=>
    (nombre.value === '' || asignado.value === '' || turno.value === '')
)


const params        = ref({});
const valid         = ref(true);
const fieldRules    = computed ( () => [ (v:string) => !!v ||  t('labels.error.required') ]);

//==================================================//
//===================== METHODS ====================//
//==================================================//

/**
 * Send all Form Data to API
 */


async function addNewUser(){
    newAdd.value    = true;

    await getParams();

    const allData = await postAddUserData(params.value)

    if( allData.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        store.dispatch('getAllUsers');
        store.commit('showSnackBar', {type: LABELS.add, msg: t('snackbar.addApis'), valor : true});

    }
}

async function editUser(){

    newAdd.value    = false;

    await getParams();
    
    const allData = await postEditUserData(params.value)

    if( allData.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        store.dispatch('getAllUsers');
        store.commit('showSnackBar', {type: LABELS.add, msg: t('snackbar.addApis'), valor : true});

    }
}

const deleteUser = async () => {

    newAdd.value = false;
    
    await getParams();

    const allData = await postDeleteUserData(params.value)

    if( allData.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){

        store.dispatch('getAllUsers');
        store.commit('showSnackBar', {type: LABELS.add, msg: t('snackbar.addApis'), valor : true});
        emitDialogClose()
    }
    
}


const getParams = async () => {
    
    params.value = {
        id : newAdd.value ? null : id.value,
        nombre : nombre.value,
        asignado : asignado.value,
        turno : turno.value
    }
}

const emitDialogClose = () => {
    emits('closeDialog');
}
     

</script>